var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUiBootstrap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 378.08 301.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 361.03,
    y1: 633.85,
    x2: 691.41,
    y2: 371.6,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9013fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6610f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 462.63,
    y1: 581.7,
    x2: 536.48,
    y2: 456.81,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1026)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1e5fc"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BootStrap logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M364.67,400.73c-.71-20.48,15.25-39.37,36.82-39.37H622.54c21.57,0,37.53,18.89,36.82,39.37-.69,19.68.2,45.17,6.62,65.95s17.29,34,35.06,35.72v19.2c-17.77,1.69-28.63,14.87-35.06,35.72s-7.3,46.27-6.62,66c.71,20.48-15.25,39.37-36.82,39.37H401.49c-21.57,0-37.53-18.89-36.82-39.37.68-19.68-.21-45.17-6.62-66s-17.31-34-35.09-35.72V502.4c17.77-1.69,28.65-14.87,35.09-35.72S365.35,420.41,364.67,400.73Z",
    transform: "translate(-322.96 -361.36)",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.2,592.09c34.93,0,56-17.1,56-45.31,0-21.32-15-36.76-37.31-39.2v-.89c16.38-2.67,29.24-17.88,29.24-34.87,0-24.21-19.11-40-48.24-40H454.33V592.09ZM479.81,452.17h33.9c18.43,0,28.9,8.22,28.9,23.1,0,15.88-12.17,24.76-34.24,24.76H479.81Zm0,119.6V519h33.67c24.12,0,36.63,8.88,36.63,26.21S537.95,571.77,515,571.77Z",
    transform: "translate(-322.96 -361.36)",
    style: {
      stroke: "#fff",
      fill: "url(#b)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiBootstrap);
export default __webpack_public_path__ + "static/media/uiBootstrap.edc7d495.svg";
export { ForwardRef as ReactComponent };